import Accordion from "../ui/Accordion";
import {
    AllSettingFormSchema,
    BankSettingFormSchema,
    GstFormSchema,
    InvoiceSettingFormSchema, OrderInvoiceSettingFormSchema
} from "../../schema/SettingSchema";
import {
    getAllSettingFormData,
    getBankSettingFormData,
    getGSTFormData,
    getInvoiceSettingFormData, getOrderInvoiceSettingFormData
} from "../../models/settingModel";
import Form from "../common/form/Form";
import React, {useEffect, useState} from "react";
import {useDispatch, useSelector} from "react-redux";
import {
    CreateGSTINNumber,
    CreateInvoiceSetting, CreatePrimaryBank, CreateToggleSetting,
    GetAllSetting, resetAllToggleSettingCreateStatus, resetOrderInvoiceSettingCreateStatus,
    CreateOrderInvoiceSetting,
    resetGSTCreateStatus,
    resetInvoiceSettingCreateStatus,
    resetPrimaryBankSettingCreateStatus
} from "../../store/setting-slice";
import AlertMessage from "../ui/AlertMessage";
import SettingDetail from "./SettingDetail";
import Button from "../common/button/Button";
import BaseModal from "../common/modal/BaseModal";
import {fetchBankList} from "../../store/list-slice";

const InvoiceSettingTab = () => {
    const [viewSettingDetail, setViewSettingDetail] = useState(false);
    const dispatch = useDispatch();
    const [alertInfo, setAlertInfo] = useState(null);
    const list = useSelector(state => state.list);

    const {
        gstNumber,
        invoice,
        orderInvoice,
        primaryBank,
        enableDisable,
        createGSTINStatus,
        createInvoiceSettingStatus,
        createOrderInvoiceSettingStatus,
        createAllToggleSettingStatus,
        createPrimaryBankStatus,
        fetchAllSettingStatus,
        GSTINError,
        invoiceSettingError,
        orderInvoiceSettingError,
        primaryBankSettingError,
        toggleSettingError,
        allSettingError
    } = useSelector(state => state.setting);
    const userRole = useSelector((state) => state.auth.selectedRole);

    const onGSTFormSubmitHandler = (data) => {
        const updatedData = {
            ...data,
            id: userRole.scopeId
        }

        dispatch(CreateGSTINNumber({
                ...userRole,
                data: updatedData
            })
        );
    };

    const onInvoiceFormSubmitHandler = (data) => {
        const updatedData = {
            ...data,
            id: userRole.scopeId
        }

        dispatch(CreateInvoiceSetting({
                ...userRole,
                data: updatedData
            })
        );
    };

    const onBankFormSubmitHandler = (data) => {
        const updatedData = {
            id: userRole.scopeId,
            ...data,
            accountNumber: Number(data.accountNumber),
        }

        dispatch(CreatePrimaryBank({...userRole, data: updatedData}))
    }

    const onOrderInvoiceFormSubmitHandler = (data) => {
        const updatedData = {
            ...data,
            id: userRole.scopeId
        }

        dispatch(CreateOrderInvoiceSetting({...userRole, data: updatedData}))
    }

    const onToggleFormSubmitHandler = (data) => {
        const updatedData = {
            ...data,
            id: userRole.scopeId
        }

        dispatch(CreateToggleSetting({...userRole, data: updatedData}))
    }

    const toggleViewSetting = () => {
        setViewSettingDetail(prev => !prev);
    };

    useEffect(() => {
        dispatch(fetchBankList({...userRole}));
        dispatch(GetAllSetting({...userRole}))
    }, [dispatch, userRole]);

    useEffect(() => {
        if (createGSTINStatus === 'success' || createInvoiceSettingStatus === 'success' || createOrderInvoiceSettingStatus === 'success' || createPrimaryBankStatus === 'success' || createAllToggleSettingStatus === 'success') {
            setAlertInfo({
                message: "Created/updated successfully.",
                variant: "success",
            });
            dispatch(resetGSTCreateStatus());
            dispatch(resetInvoiceSettingCreateStatus());
            dispatch(resetPrimaryBankSettingCreateStatus());
            dispatch(resetAllToggleSettingCreateStatus());
            dispatch(resetOrderInvoiceSettingCreateStatus());
        }
    }, [dispatch, createGSTINStatus, createInvoiceSettingStatus, createOrderInvoiceSettingStatus, createPrimaryBankStatus, createAllToggleSettingStatus])


    //GST Form
    const gstSchema = GstFormSchema();
    const gstInitialData = getGSTFormData({gstNumber});

    // Create Invoice number Form
    const invoiceSchema = InvoiceSettingFormSchema();
    const invoiceInitialData = getInvoiceSettingFormData(invoice);

    // Create Order Invoice number Form
    const orderInvoiceSchema = OrderInvoiceSettingFormSchema();
    const orderInvoiceInitialData = getOrderInvoiceSettingFormData(orderInvoice);

    // Bank Form
    const bankSchema = BankSettingFormSchema(list);
    const bankInitialData = getBankSettingFormData({accountNumber: primaryBank?.accountNumber});

    // Enable/Disable Form
    const toggleSettingSchema = AllSettingFormSchema();
    const toggleInitialData = getAllSettingFormData({enableDisable});

    return (
        <>
            <Button className="bg-primary bg-opacity-50 ms-auto d-block" onClick={toggleViewSetting}>View
                Settings</Button>

            {allSettingError && <h6 className="text-danger fs-md fw-normal">{allSettingError} </h6>}
            {fetchAllSettingStatus === 'success' &&
                <div className="row mt-5">
                    <div className="col-md-10">
                        <div className="row gy-5">
                            <div className="col-md-6 d-flex">
                                <Accordion defaultOpen={true} buttonClasses="bg-primary bg-opacity-25">
                                    <Accordion.Header>Invoice Number</Accordion.Header>
                                    <Accordion.Body>
                                        <Form
                                            onFormSubmit={onInvoiceFormSubmitHandler}
                                            schema={invoiceSchema}
                                            initialData={invoiceInitialData}
                                            status={createInvoiceSettingStatus}
                                            error={invoiceSettingError}/>
                                    </Accordion.Body>
                                </Accordion>
                            </div>

                            <div className="col-md-6 d-flex">
                                <Accordion defaultOpen={true} buttonClasses="bg-primary bg-opacity-25">
                                    <Accordion.Header>Invoice Number for Order</Accordion.Header>
                                    <Accordion.Body>
                                        <Form
                                            onFormSubmit={onOrderInvoiceFormSubmitHandler}
                                            schema={orderInvoiceSchema}
                                            initialData={orderInvoiceInitialData}
                                            status={createOrderInvoiceSettingStatus}
                                            error={orderInvoiceSettingError}/>
                                    </Accordion.Body>
                                </Accordion>
                            </div>

                            <div className="col-md-6 d-flex">
                                <Accordion defaultOpen={true} buttonClasses="bg-primary bg-opacity-25">
                                    <Accordion.Header>GSTIN Number</Accordion.Header>
                                    <Accordion.Body>
                                        <h6 className="fs-md mb-3 text-center">Create or update a GSTIN No</h6>
                                        <Form
                                            onFormSubmit={onGSTFormSubmitHandler}
                                            schema={gstSchema}
                                            inline={false}
                                            initialData={gstInitialData}
                                            status={createGSTINStatus}
                                            error={GSTINError}
                                        />
                                    </Accordion.Body>
                                </Accordion>
                            </div>

                            <div className="col-md-6 d-flex">
                                <Accordion defaultOpen={true} buttonClasses="bg-primary bg-opacity-25">
                                    <Accordion.Header>Set Primary Bank</Accordion.Header>
                                    <Accordion.Body>
                                        <h6 className="fs-md mb-3 text-center">Set primary bank</h6>
                                        <Form
                                            onFormSubmit={onBankFormSubmitHandler}
                                            schema={bankSchema}
                                            initialData={bankInitialData}
                                            status={createPrimaryBankStatus}
                                            error={primaryBankSettingError}
                                        />
                                    </Accordion.Body>
                                </Accordion>
                            </div>

                            <div className="col-md-6 d-flex">
                                <Accordion defaultOpen={true} buttonClasses="bg-primary bg-opacity-25">
                                    <Accordion.Header>Enable/Disable Settings</Accordion.Header>
                                    <Accordion.Body>
                                        <h6 className="fs-md mb-3 text-center">Enable/Disable Settings for Invoice</h6>
                                        <Form
                                            onFormSubmit={onToggleFormSubmitHandler}
                                            schema={toggleSettingSchema}
                                            initialData={toggleInitialData}
                                            status={createAllToggleSettingStatus}
                                            error={toggleSettingError}
                                        />
                                    </Accordion.Body>
                                </Accordion>
                            </div>
                        </div>
                        {alertInfo && (
                            <AlertMessage
                                message={alertInfo.message}
                                variant={alertInfo.variant}
                                duration={2000}
                                onClose={() => setAlertInfo(null)}
                            />
                        )}
                    </div>

                    <BaseModal isOpen={viewSettingDetail} size='modal-lg'>
                        <SettingDetail invoiceSetting={invoice}
                                       enableDisable={enableDisable}
                                       GSTIN={gstNumber}
                                       primaryBank={primaryBank}
                                       orderInvoice={orderInvoice}
                                       closeModal={toggleViewSetting}/>
                    </BaseModal>
                </div>
            }
        </>
    )
}

export default InvoiceSettingTab;